<template>
  <div class="exploitant">
    <h4 class="mb-3 infos-title">SOCIETE DE PROJET EXPLOITANTE</h4>
    <hr class="mx-0 mb-2" />
    <div v-if="parc.id">
      <p v-if="parc.raisonSociale">
        Raison sociale : <i>{{ parc.raisonSociale }}</i>
      </p>
      <p v-if="parc.siret">
        Siret : <i>{{ parc.siret }}</i>
      </p>
    </div>
    <div v-else>
      <p>
        <i class="empty-field">{{ emptyField }}</i>
      </p>
    </div>
  </div>
</template>

<script setup>
// MapGetters from store
import {useReactiveStoreGetters} from "@/composables/useStore";

const {parc} = useReactiveStoreGetters(['parc']);

</script>
